export enum AppRoutes {
  categories = '/categories',
  productTypes = '/product-types',
  searchProductTypes = '/product-types/search',
  assetAvailability = '/asset-availability',
  assetUnavailability = '/asset-unavailability',
  equipmentAsset = '/equipment-asset',
  restricted = '/restricted',
  settings = '/settings',
  clientSelection = '/settings/client-selection',
  customerSelection = '/settings/customer-selection',
  locationSettings = '/settings/location-settings',
  productSortSettings = '/settings/product-sort',
  estimateSettings = '/settings/estimate-type',
  unavailableAssets = '/equipment-unavailable-asset',
  filters = '/filters',
  filter = '/filters/:filterName',
}
